module.exports = __webpack_public_path__ + "static/img/product-brand.905a828.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/product-brand.png
// module id = cgvZ
// module chunks = 58